import { ENV } from "@/lib/env";

export const appConfig = {
  apiBaseUrl: ENV.API_FLAVOUR === "dev" ? ENV.API_BASE_URL : "",
  API_FLAVOUR: ENV.API_FLAVOUR,
};
